/**
 * Adapptio Editor
 *
 * @package editor
 * @copyright 2021-2025 Hexio a.s. <contact@hexio.io> (hexio.io) and contributors.
 * @license Apache-2.0
 *
 * See LICENSE file distributed with this source code for more information.
 */

export const termsEditorViewEditor = {
	commands: {
		toggleLeftPanel: "viewEditor:commands.toggleLeftPanel#label",
		toggleRightPanel: "viewEditor:commands.toggleRightPanel#label",
		hideAllPanels: "viewEditor:commands.hideAllPanels#label",
		toggleConsole: "viewEditor:commands.toggleConsole#label",
		saveResource: "viewEditor:commands.saveResource#label",
		// deleteResource: "viewEditor:commands.deleteResource#label"
		deleteSelection: "viewEditor:commands.deleteSelection#label",
		unselectAll: "viewEditor:commands.unselectAll#label",
		openMainView: "viewEditor:commands.openMainView#label",
		exportYaml: "viewEditor:commands.exportYaml#label",
		undo: "viewEditor:commands.undo#label",
		redo: "viewEditor:commands.redo#label"
	},
	mainMenu: {
		sectionCreate: {
			view: {
				label: "viewEditor:mainMenu.sectionCreate.view#label",
				tooltip: "viewEditor:mainMenu.sectionCreate.view#tooltip"
			}
		}
	},
	inspector: {
		selectComponentToInspect: "viewEditor:inspector.selectComponentToInspect",
		cannotEditMultipleComponents: "viewEditor:inspector.cannotEditMultipleComponents",
		cannotEditMultipleEventNodes: "viewEditor:inspector.cannotEditMultipleEventNodes"
	},
	viewSettings: {
		label: "viewEditor:viewSettings#label",
		openDocumentation: "viewEditor:viewSettings.openDocumentation#label"
	},
	toasts: {
		creatingDirectory: "viewEditor:toasts.creatingDirectory#message",
		movingResource: "viewEditor:toasts.movingResource#message",
		savingView: "viewEditor:toasts.savingView#message",
		savingAllViews: "viewEditor:toasts.savingAllViews#message",
		viewHasBeenSaved: "viewEditor:toasts.viewHasBeenSaved#message",
		allViewsHaveBeenSaved: "viewEditor:toasts.allViewsHaveBeenSaved#message",
		failedToSaveView: "viewEditor:toasts.failedToSaveView#message"
	},
	other: {
		historyNotAvailableYet: "viewEditor:other.historyNotAvailableYet#tooltip"
	}
};
